import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Skeleton } from '@mui/material';
import { SlidingBanner } from '../../../interfaces/SlidingBanner/SlidingBanner';
import { getSlidingBanners } from '../../../api/SlidingBanner';
import { SlidingBannerCmp } from './SlidingBannerCmp';

export const SlidingBanners = () => {
  const [slidingBanners, setSlidingBanners] = useState<SlidingBanner[]>([]);
  const [loading, setLoading] = useState(false);

  const refreshSlidingBanners = () => {
    setLoading(true);
    getSlidingBanners()
      .then((s) => setSlidingBanners(s))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshSlidingBanners();
  }, []);

  if (loading) {
    return <Skeleton variant='rectangular' width='100%' height={35} />;
  }

  return (
    <>
      {slidingBanners
        .filter((sb) => sb.isActive)
        .map((sb) => (
          <SlidingBannerCmp key={sb.id} slidingBanner={sb} />
        ))}
    </>
  );
};
